<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Time Zone</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <div class="alert alert-warning" role="alert" v-if="[3, 4].includes(logged_in_user.group_id)">
          <b>Notice:</b> Changing the Time Zone takes effect immediately.
        </div>
        <form>
          <div class="form-group">
            <label>Current Time Zone</label>
            <input type="text" class="form-control" disabled="disabled" :value="current_time_zone" />
          </div>
          <div class="form-group" v-if="[3, 4].includes(logged_in_user.group_id)">
            <label for="ddlTimeZone">Set Time Zone</label>
            <select class="form-control" id="ddlTimeZone" v-model="updated_time_zone">
              <option value="0">Select..</option>
              <option v-for="time_zone in time_zones" :key="time_zone" v-bind:value="time_zone">{{ time_zone }}
              </option>
            </select>
          </div>
          <button type="submit" class="btn btn-hub-primary" @click="save()" v-if="[3, 4].includes(logged_in_user.group_id)">Set</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'time-zone',
  data: function () {
    return {
      updated_time_zone: '0'
    }
  },
  computed: mapGetters({
    time_zones: 'allTimeZones',
    current_time_zone: 'currentTimeZone',
    logged_in_user: 'loggedInUser'
  }),
  methods: {
    save () {
      this.$store.dispatch('setCurrentTimeZone', this.updated_time_zone)
    }
  },
  created () {
    this.$store.dispatch('getTimeZones')
    this.$store.dispatch('getCurrentTimeZone')
  }
}
</script>

<style scoped>

</style>
